export const UPDATE_MARKETS_DETAILS = 'UPDATE_MARKETS_DETAILS';
